import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button2", component(opts));
  editor.BlockManager.add("button2", block(opts));
};